import { CONTACT_EMAIL, CONTROLLER_NAME, LegalDocument } from './legalDocument';

export const termsOfUse: LegalDocument = {
  title: 'Termos de Uso',
  updated: '27 de outubro de 2026',
  intro: [
    'Estes termos explicam as regras para usar o Financy: o site financybr.com, o painel e o Fin no Telegram. Ao criar uma conta ou usar o Fin, você concorda com eles. Leia também a Política de Privacidade, que explica como tratamos os seus dados.',
  ],
  sections: [
    {
      title: 'O que é o Financy',
      paragraphs: [
        'O Financy é um assistente para organizar dinheiro por mensagem. Você conta ao Fin o que gastou ou recebeu, por texto, áudio ou foto do recibo, e ele organiza os lançamentos, as contas a pagar, as metas e as divisões em grupo.',
        'O serviço está em fase beta: pode mudar, ganhar ou perder funções e ter instabilidades.',
      ],
    },
    {
      title: 'A sua conta',
      items: [
        'Você precisa ter 18 anos ou mais.',
        'Mantenha os seus dados corretos e a sua senha em segurança. O que for feito com a sua conta é responsabilidade sua.',
        'Conecte ao Financy apenas a sua própria conta do Telegram.',
        `Se suspeitar de uso indevido da sua conta, avise em **${CONTACT_EMAIL}**.`,
      ],
    },
    {
      title: 'Como o Fin funciona, e os seus limites',
      items: [
        'O Fin usa inteligência artificial para entender mensagens, áudios e recibos, e pode errar. Ele mostra o que entendeu e só salva depois que você confirma: confira antes de confirmar.',
        'O Financy não acessa contas bancárias nem cartões, não faz pagamentos e não movimenta dinheiro. Ele registra o que você conta.',
        'Totais, saldos e projeções são calculados a partir do que foi registrado. Não são extrato bancário nem garantia de resultado.',
        'O Financy não presta consultoria financeira, contábil, jurídica ou de investimentos.',
      ],
    },
    {
      title: 'Grupos',
      items: [
        'Ao adicionar o Fin a um grupo do Telegram ou entrar num grupo do Financy, o que você registra ali fica visível para os participantes.',
        'Quem administra o grupo define quem participa e como os gastos são divididos.',
        'Os acertos registrados no Financy são anotações: o pagamento de verdade acontece fora do app, entre as pessoas.',
        'Se você sair de um grupo ou excluir a sua conta, os gastos do grupo em que você participou continuam, para os saldos dos outros fecharem, como explica a Política de Privacidade.',
      ],
    },
    {
      title: 'Uso permitido',
      paragraphs: ['Você não pode usar o Financy para:'],
      items: [
        'atividades ilegais ou para registrar dados de outras pessoas sem ter o direito de fazer isso;',
        'tentar acessar contas, dados ou sistemas que não são seus;',
        'enviar conteúdo ofensivo, ou sobrecarregar ou atrapalhar o serviço, inclusive com automações.',
      ],
      after: ['Podemos suspender ou encerrar contas que descumpram estes termos.'],
    },
    {
      title: 'Preço e vagas de fundador',
      items: [
        'Hoje, o Financy é gratuito.',
        'As 50 primeiras contas criadas no Financy, por ordem de cadastro, são de fundadores. Quando os planos pagos forem lançados, quem é fundador ganha 6 meses sem pagar, contados a partir do lançamento.',
        'Não pedimos cartão de crédito. Antes de qualquer cobrança, avisamos pelo Telegram e por e-mail, e você decide se continua. Nada é cobrado sem a sua escolha.',
        'Planos, preços e limites futuros serão informados antes de começarem a valer.',
      ],
    },
    {
      title: 'Exclusão e inatividade',
      items: [
        'Você pode excluir a sua conta a qualquer momento, em **Ajustes → Excluir conta**.',
        'Contas sem uso por 6 meses são apagadas, com aviso 30 dias antes, como explica a Política de Privacidade.',
        'Se um dia o Financy for encerrado, avisaremos com antecedência e você poderá pedir uma cópia dos seus dados antes disso.',
      ],
    },
    {
      title: 'Responsabilidade',
      paragraphs: [
        'Fazemos o possível para o Financy funcionar bem e manter os seus dados seguros. Mas, por estar em fase beta e depender de serviços de terceiros, como o Telegram, ele pode ter falhas, interrupções ou erros de leitura.',
        'Na medida permitida pela lei, não respondemos por decisões tomadas com base nos números do app nem por perdas causadas por registros que você confirmou com erro. Nada nestes termos limita os direitos que você tem pelo Código de Defesa do Consumidor.',
      ],
    },
    {
      title: 'Mudanças nestes termos',
      paragraphs: [
        'Podemos atualizar estes termos. Mudanças importantes serão avisadas por e-mail ou no app antes de valer. Se continuar usando o Financy depois disso, você concorda com a nova versão; se não concordar, pode excluir a sua conta.',
      ],
    },
    {
      title: 'Lei e foro',
      paragraphs: ['Estes termos seguem as leis do Brasil. Eventuais disputas serão resolvidas no foro do seu domicílio.'],
    },
    {
      title: 'Contato',
      paragraphs: [`${CONTROLLER_NAME} · **${CONTACT_EMAIL}**`],
    },
  ],
};
